<script setup lang="ts">
const { t } = useI18n()

useHead({
  title: computed(() => t('layouts.title', [t('form.sign_out.label')])),
})
</script>

<template>
  <div>
    <UiButton
      id="sign-out"
      variant="orange"
      class="w-full justify-center rounded-full fw600 leading-8"
      @click="authLogout"
    >
      {{ t('form.sign_out.label') }}
    </UiButton>
  </div>
</template>
